import React, { useEffect, useState } from "react";
import Joyride from "react-joyride";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import Swal from "sweetalert2";
import { customerservice, userManagementUrl } from "../../../../config";
import {
  executeAnyMutation,
  fetchJsonDynamic,
} from "../../../../data/DynamicServiceNew/jsondynamicservice";

const SingularMigrationPage = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userRoleGroup = parseInt(decodedToken.RoleGroupId);
  const userId = parseInt(decodedToken.Id);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCustomer, setFilteredCustomer] = useState(null);
  const [fieldOfficerSelected, setFieldOfficerSelected] = useState("");
  const [fieldOfficerData, setFieldOfficerData] = useState([]);

  const [runTour, setRunTour] = useState(true);
const [steps] = useState([
  {
    target: ".search-customer",
    content: "Start by searching for a customer using phone number, ID, or passport.",
  },
  {
    target: ".customer-details-card",
    content: "Here you can view the selected customer's details.",
  },
  {
    target: ".ro-details-card",
    content: "Assign a Field Officer (RO) for this customer.",
  },
  {
    target: ".migration-submit-button",
    content: "Click this button to complete the customer migration.",
  },
]);
  useEffect(() => {
    const fetchFieldOfficers = async () => {
      const fieldOfficerDataResponse = await fetchJsonDynamic(
        "allUsersView",
        null,
        null,
        userManagementUrl.uri
      );
      if (fieldOfficerDataResponse?.results) {
        const results = JSON.parse(fieldOfficerDataResponse.results);
        const activeFieldOfficers = results.filter(
          (user) => user.RoleGroupId === 5 && user.IsActive === 1
        );
        setFieldOfficerData(activeFieldOfficers || []);
      }
    };
    fetchFieldOfficers();
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (searchTerm) {
        try {
          const isPhoneNumber = searchTerm.length >= 10;
          
          const variables = isPhoneNumber 
            ? { mobileNumber: searchTerm }
            : { idNoOrPassport: searchTerm };

          const response = await fetchJsonDynamic(
            "customersByColumnValuesLatest",
            "customer",
            variables,
            customerservice.uri
          );

          const customerData = JSON.parse(response.results);
          
          if (customerData && customerData.length > 0) {
            setFilteredCustomer(customerData[0]);
          } else {
            setFilteredCustomer(null);
            Swal.fire("Customer Not Found", "Customer does not exist", "warning");
          }
        } catch (error) {
          console.error("Error fetching customer:", error);
          setFilteredCustomer(null);
          Swal.fire("Error", "Failed to search customer", "error");
        }
      } else {
        setFilteredCustomer(null);
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleCustomerMigrationSubmit = async () => {
    try {
      const mutationData = {
        pcustomerId: filteredCustomer.Id,
        pFoId: fieldOfficerSelected,
        pdoneBy: userId,
      };

      const response = await executeAnyMutation(
        "executeSingularCustomerFoMigration",
        mutationData,
        "inputModel",
        false,
        customerservice.uri
      );
      
      if (response.results === "200") {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Customer Migrated successfully",
        }).then(() => {
          setSearchTerm("");
          setFilteredCustomer(null);
          setFieldOfficerSelected("");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: response.error || "An unexpected error occurred.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Joyride
  steps={steps}
  run={runTour}
  showSkipButton
  showProgress
  continuous
  styles={{
    options: {
      primaryColor: "#1976d2",
      zIndex: 10000,
    },
  }}
/>
<Button onClick={() => setRunTour(true)}>Start Tour</Button>

   <Box className="search-customer">
      <Typography variant="h5">Search Customer:</Typography>
      <TextField
        label="Search Customer by customer phone number | ID No. | Passport"
        placeholder="Enter search criteria"
        variant="outlined"
        fullWidth
        margin="normal"
        value={searchTerm}
        onChange={handleSearchChange}
      />
   </Box>
      {filteredCustomer && (
        <>
          <Card variant="outlined" sx={{ mb: 2 }} className="customer-details-card">
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Customer Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Customer Name:</strong> {filteredCustomer.FirstName}{" "}
                    {filteredCustomer.OtherNames}{" "}
                  </Typography>
                  <Typography>
                    <strong>Email:</strong> {filteredCustomer.EmailAddress}
                  </Typography>
                  <Typography>
                    <strong>ID Number:</strong>{" "}
                    {filteredCustomer.IdNoOrPassport}
                  </Typography>
                  <Typography>
                    <strong>Field Officer:</strong>{" "}
                    {filteredCustomer.FieldOfficerName || "Not Assigned"} 
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Mobile Number:</strong>{" "}
                    {filteredCustomer.MobileNumber}
                  </Typography>
                  <Typography>
                    <strong>Branch:</strong> {filteredCustomer.BranchName}
                  </Typography>
                  <Typography>
                    <strong>Date Created:</strong>{" "}
                    {filteredCustomer.DateCreated}
                  </Typography>
                  <Typography>
                    <strong>Current Loan Limit:</strong>{" "}
                    {filteredCustomer.LoanLimit}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ mb: 2 }} className="ro-details-card">
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                RO Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Field Officer</InputLabel>
                    <Select
                      value={fieldOfficerSelected}
                      onChange={(e) => setFieldOfficerSelected(e.target.value)}
                      defaultValue=""
                    >
                      <MenuItem value="" disabled>
                        Select Field Officer
                      </MenuItem>
                      {fieldOfficerData.map((company) => (
                        <MenuItem key={company.Id} value={company.Id}>
                          {company.FirstName} {company.LastName} - {company.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Button
            className="migration-submit-button"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleCustomerMigrationSubmit}
          >
            Submit For Customer Migration
          </Button>
        </>
      )}
    </Box>
  );
};

export default SingularMigrationPage;